import React, {
  useEffect,
  useRef,
  InputHTMLAttributes,
  RefObject,
} from 'react';

import { useField } from '@unform/core';
import { FormControlLabel } from '@material-ui/core';

interface Props {
  name: string;
  options: {
    id: string;
    value: string;
    label: string;
  }[];
}

type RefInputEl = RefObject<HTMLInputElement[]>;

type InputProps = InputHTMLAttributes<HTMLInputElement> & Props;

const Radio: React.FC<InputProps> = ({
  name,
  options,
  ...rest
}: InputProps) => {
  const inputRefs = useRef([]);
  const { fieldName, registerField, defaultValue = '', error } = useField(name);

  useEffect(() => {
    registerField({
      name: fieldName,
      ref: inputRefs,
      getValue: (refs: RefInputEl) => {
        if (!refs.current) return '';

        return refs.current.find((input) => input?.checked)?.value || '';
      },
      setValue: (refs: RefInputEl, id: string) => {
        if (refs.current) {
          const inputRef = refs.current.find((ref) => ref.id === id);
          if (inputRef) inputRef.checked = true;
        }
      },
      clearValue: (refs: RefInputEl) => {
        if (refs.current) {
          const inputRef = refs.current.find((ref) => ref.checked === true);
          if (inputRef) inputRef.checked = false;
        }
      },
    });
  }, [fieldName, registerField]);

  return (
    <div
      style={{
        display: 'flex',
        width: '100%',
        margin: '5px',
        padding: '5px',
        justifyContent: 'space-around',
      }}
    >
      {options.map((option, index) => (
        <FormControlLabel
          key={option.id}
          label={option.label}
          /* prettier-ignore */
          control={(
            <input
              type="radio"
              ref={(ref) => {
                  inputRefs.current[index] = ref as never;
                }}
              id={option.id}
              name={name}
              defaultChecked={defaultValue === option.value}
              value={option.value}
              {...rest}
            />
            )}
          labelPlacement="start"
        />
      ))}

      {error && <span>{error}</span>}
    </div>
  );
};

export default Radio;
